// @mui
import { Container, Grid } from '@mui/material';

import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores/store';

//Localization
import useLocales from 'src/hooks/useLocales';
import Page from 'src/components/Page';
import useSettings from 'src/hooks/useSettings';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import { PATH_DASHBOARD } from 'src/routes/paths';
import BlockDetailTableRow from './BlockDetailTableRow';
import { useEffect, useState } from 'react';
import Loader from 'src/components/loader/Loader';
// ----------------------------------------------------------------------
export default observer(function BlockDetailHeader() {
  const { translate } = useLocales();
  const {
    BlockStore: { selectedBlockDetail, clearSelectedBlock, ID, loadBlockDetail },
  } = useStore();

  const [isLoading, setIsLoading] = useState(true); // Track loading state

  useEffect(() => {
    if (ID) {
      setIsLoading(true);
      loadBlockDetail(ID).finally(() => setIsLoading(false)); // Ensure loading ends
    }
  }, [loadBlockDetail, ID]);

  const { themeStretch } = useSettings();

  // Handle case when no ID or data is available
  if (!ID) {
    return (
      <Page title={translate('Block.BlockDetails')}>
        <Container maxWidth={themeStretch ? false : 'lg'}>
          <HeaderBreadcrumbs
            heading={translate('Block.BlockDetails')}
            links={[
              { name: `${translate('Department.Dashboard')}`, href: PATH_DASHBOARD.root },
              { name: `${translate('Block.Block')}`, href: PATH_DASHBOARD.Block.list },
            ]}
          />
          <p>{translate('Block.NoData')}</p>
        </Container>
      </Page>
    );
  }

  return (
    <Page title={translate('Block.BlockDetails')}>
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={translate('Block.BlockDetails')}
          links={[
            { name: `${translate('Department.Dashboard')}`, href: PATH_DASHBOARD.root },
            { name: `${translate('Block.BlockDetails')}`, href: PATH_DASHBOARD.Block.list },
          ]}
        />
        {isLoading ? ( // Show loading state
          <Grid container justifyContent="center" alignItems="center" style={{ height: '50vh' }}>
              <Loader />
          </Grid>
        ) : selectedBlockDetail ? ( // Render details if available
          <Grid container>
            <BlockDetailTableRow row={selectedBlockDetail} clearBlock={clearSelectedBlock} />
          </Grid>
        ) : (
          <Grid container justifyContent="center" alignItems="center" style={{ height: '50vh' }}>
            <p>{translate('userBlock.NoDetailsFound')}</p>
          </Grid>
        )}
      </Container>
    </Page>
  );
});
